// extracted by mini-css-extract-plugin
module.exports = {"container":"ToastAlert_container__1jyJu","item":"ToastAlert_item__1axzR","body":"ToastAlert_body__3erlk","close":"ToastAlert_close__35pb7"};